import { render, staticRenderFns } from "./ParallelUserDetail.vue?vue&type=template&id=7f2e989e&scoped=true"
import script from "./ParallelUserDetail.vue?vue&type=script&lang=js"
export * from "./ParallelUserDetail.vue?vue&type=script&lang=js"
import style0 from "./ParallelUserDetail.vue?vue&type=style&index=0&id=7f2e989e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e989e",
  null
  
)

export default component.exports